export default class WsStepperController {
  isActiveStep = step => step.id === this.activeStep;
}



// WEBPACK FOOTER //
// ./src/stepper/ws-stepper.controller.js